import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

export default function NumberInputIntroduction(props) {
  return (
    <Box
      component="form"
      sx={{
        "& .MuiTextField-root": {
          m: 1,
          width: "235px",
          marginLeft: 0,
          marginRight: 1,
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "#000000", // default border color
          },
          "&:hover fieldset": {
            borderColor: "#800080", // purple color on hover
          },
          "&.Mui-focused fieldset": {
            borderColor: "#800080", // purple color on focus
          },
        },
      }}
      noValidate
      autoComplete="off"
    >
      <TextField
        disabled={props.Disabled}
        id="outlined-number"
        label={props.Label ? props.Label : "Available credits"}
        type={props.type ? props.type : "number"}
        value={props.Value}
        required={props.Required}
        error={props.HasError}
        helperText={props.ErrorText}
        onChange={(event) => props.OnChange(event.target.value)}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{
          pointerEvents: props.Disabled ? "none" : "all",
          "& .MuiTextField-root": { maxWidth: "225px" },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#c4c4c4", // default border color
            },
            "&:hover fieldset": {
              borderColor: "#FB4764", // purple color on hover
            },
            "&.Mui-focused fieldset": {
              borderColor: "#FB4764", // purple color on focus
            },
          },
        }}
      />
    </Box>
  );
}
